export default "__VITE_ASSET__cb0edf99__"